import {
  FETCH_SUBSCRIPTION_CHARGE,
  CREATE_SUBSCRIPTION_CHARGE,
  UPDATE_SUBSCRIPTION_CHARGE,
} from '../constants';

const subscriptionCharges = (state = [], action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_CHARGE:
      return action.payload;
    case CREATE_SUBSCRIPTION_CHARGE:
      return [action.payload, ...state];
    case UPDATE_SUBSCRIPTION_CHARGE:
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
    default:
      return state;
  }
};

export default subscriptionCharges;

export const getSubscriptionCharges = state => state.admin.subscriptions.subscriptionCharges;
